import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AuthService } from "src/app/auth-section/auth-service/auth.service";
import { PatientsService } from "../patient-service/patients.service";
import { MessageService } from "primeng/api";
import { ConfirmationService } from "primeng/api";
import { PatientlocalService } from "../patient-service/patientlocal.service";

@Component({
  selector: "app-patients",
  templateUrl: "./patients.component.html",
  styleUrls: ["./patients.component.css"],
  providers: [MessageService, ConfirmationService],
})
export class PatientsComponent implements OnInit {
  isData = true;
  token: string;
  filter;
  isSearch = false;
  searchQuery = null;
  patData = [];
  id: string;
  config: { itemsPerPage: number; currentPage: number; totalItems: number };
  page: number = 1;
  totalItems: number = 0;
  allTotal: number;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private patientsService: PatientsService,
    private conformationService: ConfirmationService,
    private patientLocalService: PatientlocalService
  ) {}

  ngOnInit() {
    this.authService.authDataSubject.subscribe((res) => {
      this.token = res._token;
    });
    this.getPatients("1");
    this.initConfig();
  }
  onAddPatients() {
    this.router.navigate(["register"], {
      relativeTo: this.activatedRoute,
    });
  }
  getPatients(page) {
    this.patientsService
      .getPatientsFromDb(this.token, page)
      .subscribe((res) => {
        this.patData = res.patData;

        this.page = +res.page;
        if (this.page === 1) {
          this.patientLocalService.savePatient(this.patData);
          this.allTotal = res.total;
        }
        this.totalItems = res.total;
        this.initConfig();
      });
  }
  onPatientClicked(index) {
    localStorage.setItem("patid", JSON.stringify(index));
    this.router.navigate(["profile"], {
      relativeTo: this.activatedRoute,
      queryParams: { patid: index },
    });
  }

  onUpdatePatient(event, index) {
    event.stopPropagation();
    this.router.navigate(["register"], {
      relativeTo: this.activatedRoute,
      queryParams: { id: index },
    });
  }
  onDeletePatients(event, index) {
    this.conformationService.confirm({
      message: "Are you sure that you want to perform this action?",
      accept: () => {
        this.patientsService
          .deletePatient(index, this.token)
          .subscribe((res) => {
            this.patData.splice(index, 1);
          });
        //Actual logic to perform a confirmation
      },
    });
    event.stopPropagation();
  }
  initConfig() {
    this.config = {
      itemsPerPage: 10,
      currentPage: this.page,
      totalItems: this.totalItems,
    };
  }
  pageChanged(event) {
    this.config.currentPage = event;
    if (this.isSearch && this.searchQuery) {
      this.serachPatients(this.searchQuery, this.config.currentPage);
    } else {
      this.getPatients(this.config.currentPage);
    }
  }

  onSearchChange(value) {
    if (value) {
      this.searchQuery = value;
      this.serachPatients(value, 1);
      this.isSearch = true;
    } else {
      this.patData = this.patientLocalService.getPatients();
      this.page = 1;
      this.isSearch = false;
      this.totalItems = this.allTotal;
      this.searchQuery = null;
    }
  }
  
  serachPatients(value, pagNo) {
    this.patientsService
      .onSearchPatient(value, this.token, pagNo)
      .subscribe((res) => {
        this.patData = res.patData;

        this.page = +res.page;

        this.totalItems = res.total;
        this.initConfig();
      });
  }
}
